<template>
    <div class="row">
      <div class="col-12 card">
        <div class="row justify-content-space-between top-24">

        <h4 class="col-3 card-title">Список автомобилей организации</h4>
        <div class="col-9 align-self-end right">
          <router-link to="/polygon/new_waste_car" class="col-3 btn-primary"><span class="icon-Plus"></span>Добавить автомобиль</router-link>
        </div>

            <div class="col-12">
              <div class="row justify-content-space-between">
                <CarsList/>
              </div>
            </div>
        </div>

      </div>
    </div>
</template>
  
  <script>
    import CarsList from "@/components/Polygon/WasteCars/WasteCarsList.vue";
  
    export default {
      components: { CarsList },
      data() {
        return {
          title: "Список автомобилей",
        }
      },
      computed: {

      },
    };
  </script>

<style scoped>
.col-12 {
  display: block;
  width: 100%;
}
</style>